import React from 'react';
import { Link } from 'react-router-dom';
import InputText from '../../components/InputText.jsx';
import TranslationText from '../../components/Translation/TranslationText.jsx';
import { PhonePrefixSelector } from '../../components/PhonePrefixSelector.jsx';

export function PhoneNumberInput({ 
  model, 
  selectedPrefixId, 
  errors, 
  maxPhoneLength, 
  businessLogin,
  onChange,
  onDropDownChange,
  initialData
}) {
  const hasError = (errors['username']?.length > 0) || (errors['onLogin']?.length > 0);

  return (
    <>
      <label htmlFor="email" className="form-field__label">
        <TranslationText text="login_with_phone_number_page_phone_field_title" />
      </label>
      <div className="form-group no-margin-bottom">
        <div className={hasError ? "form-row -phone-number -has-error" : "form-row -phone-number"}>
          <PhonePrefixSelector
            initialPrefix={selectedPrefixId}
            onChange={onDropDownChange}
            phonePrefixes={initialData.phonePrefixes}
          />
          <div className="form-field">
            <InputText
              onChange={onChange}
              prop="username"
              value={model.username}
              className="form-field__input -tel"
              type="tel"
              maxLength={maxPhoneLength}
            />
          </div>
        </div>
        {!businessLogin && (
          <Link className="link-button link-button-small" to="/PasswordRecovery/RemindEmail">
            <TranslationText text="login_page_remind_email_btn" />
          </Link>
        )}
        <label className="sublabel error-msg show padding-bottom">
          <TranslationText text={errors['username']} />
        </label>
      </div>
    </>
  );
}